import { render, staticRenderFns } from "./AddDocumentType.vue?vue&type=template&id=0ff47c86&"
import script from "./AddDocumentType.vue?vue&type=script&lang=ts&"
export * from "./AddDocumentType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports